import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TopBar from "../../topbar/TopBar.js";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import "../../visitor/visitor-create/visitor-create.css";
import DOMPurify from "dompurify";
import SearchWithAPI from "../../common/searchbox/searchbox.js";
import MultiSelectDropDown from "../../common/searchbox/multi-select-dropdown.js";
import AsyncSelect from "react-select/async";
import { ReactComponent as BackIcon } from "../../../assets/svg/nav-prev.svg";
import { createGateTemplateApi, createTemplateApi, createWhatsappTemplateApi, getGateTemplateDetailsApi, getTemplateDetailsApi, updateGateTemplateApi, updateTemplateApi } from "../../modal-dialog/setup-api.js";
import { } from "../../../components/modal-dialog/setup-api.js";
import { getGateListApi } from "../registerfields/registerfield-api.js";

import { ReactComponent as UploadIcon } from "../../../assets/svg/upload_btn.svg";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import PoweredBy from "../../common/poweredBy.jsx";

export const TemplateAdd = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

  const multiselectCustomStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      border: "0.7px solid #E5E5E5",
      padding: "2px",
      fontWeight: "500",
      fontSize: "13px",
      color: "#212129",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e0e0e0" : "#fff",
      color: state.isSelected ? "#fff" : "#333",
      padding: 10,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#F6F7F8",
      color: "#212129",
      borderRadius: "5px",
      padding: "2px 5px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#212129",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#212129",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };

  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};
  const [errorMessage, setErrorMessage] = useState("");
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "end",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",

      borderRadius: "0px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "618px",
      height: "100vh",
      overflowY: "auto",
    },
  };

  const [loading, setLoading] = useState(false);
  const [templateCode, setTemplateCode] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [status, setStatus] = useState("Active");
  const [typeOption, setTypeOption] = useState(null);
  const [mediumOption, setMediumOption] = useState(null);
  const [title, setTitle] = useState("");
  const [headerType, setHeaderType] = useState("");

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [contentValue, setContentValue] = useState("");

  useEffect(() => { }, []);

  const [validations, setValidations] = useState({
    code: "",
    name: "",
    type: "",
    template: "",
  });
  function convertTo12Hour(time24) {
    const [hour, minute] = time24.split(":");
    const h = parseInt(hour);
    const suffix = h >= 12 ? "PM" : "AM";
    const hour12 = h % 12 || 12; // convert 0 to 12
    const formattedHour = hour12.toString().padStart(2, "0");
    const formattedMinute = minute.toString().padStart(2, "0");
    return `${formattedHour}:${formattedMinute} ${suffix}`;
  }
  useEffect(() => {
    if (id != null) {
      getTemplateDetails();
    }
  }, []);

  const getTemplateDetails = async () => {
    try {
      const response = await getGateTemplateDetailsApi(id);
      if (response.status === true && response.config) {
        const templateDetails = response.config;
        console.log(templateDetails);
        setTemplateCode(templateDetails.code ?? "");
        setTemplateName(templateDetails.name ?? "");
        setContentValue(templateDetails.template ?? "");
        setGate(templateDetails.gates ?? []);
      }
    } catch (err) {
      console.error("Error fetching template:", err);
    }
  };

  const submitTemplate = async () => {
    const dataBeforeSanitize = {
      code: templateCode,
      name: templateName,
      type: "Vehicle",
      gates: gate?.filter((item) => item.value !== "").map((item) => item.value),
      template: contentValue,
    };
    const dataAfterSanitize = {};
    Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
      if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
        dataAfterSanitize[key] = value;
      } else {
        dataAfterSanitize[key] = DOMPurify.sanitize(value);
      }
    });
    if (id == null) {
      const response = await createGateTemplateApi(dataAfterSanitize);
      if (response.status === 200) {
        if (response.data.status === true) {
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.status);
          handleSnackbarShow();
          navigate(-1);
        }
      }

      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            code: "",
            name: "",
            type: "",
            template: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setValidations(validationTemp);
        });
      }
    } else {
      const response = await updateGateTemplateApi(dataAfterSanitize, id);
      if (response.status === 200) {
        if (response.data.status === true) {
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.status);
          handleSnackbarShow();
          navigate(-1);
        }
      }
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            code: "",
            name: "",
            medium: "",
            template: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setValidations(validationTemp);
        });
      }
    }
  };

  //Gate
  const [gate, setGate] = useState([]);
  const fetchGate = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getGateListApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };

  const handleGateChange = (selectedOptions) => {
    setGate(selectedOptions);
  };

  return (
    <Container fluid className="main-container">
      <div style={{ width: "100vw" }}>
        <TopBar />
        <Row sm={12} className="main-row">
          <Col className="mx-2" sm={12} style={{ padding: "16px" }}>
            <Row sm={12}>
              <Col sm={6} md={9}>
                <div className="style-justify-start">
                  <div onClick={() => navigate(-1)} style={{ cursor: "pointer", width: "40px", height: "40px", display: "flex", alignItems: "center" }}>
                    <BackIcon />
                  </div>
                  <span style={{ fontSize: "16px", fontWeight: "700", color: "#21272C" }}>Add templates</span>
                </div>
              </Col>
              <Col sm={6} md={3}>
                <div className="style-justify-end" style={{ gap: "8px" }}>
                  <div className="cancel_btn" onClick={() => navigate(-1)}>
                    <div style={{ fontSize: "14px", fontWeight: "400", color: "#21272C" }}>Cancel</div>
                  </div>
                  <div className="success_btn" onClick={() => submitTemplate()}>
                    <div style={{ fontSize: "14px", fontWeight: "400", color: "#FFFFFF" }}>Submit</div>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="card-view mt-2">
              <Row>
                <Col xs={12} sm={12} lg={8}>
                  <div className="card-title mb-3">Template details</div>
                  <Row style={{ display: "flex" }}>
                    <Col xs={12} sm={12} md={6}>
                      <div className="field-title">
                        Code<span style={{ color: "#FF4444" }}>*</span>
                      </div>
                      <input type="text" placeholder="Enter here" className="input-field mt-2 w-100 mb-2" value={templateCode} onChange={(e) => setTemplateCode(e.target.value)} />
                      <span className="field-error">{validations.code}</span>
                    </Col>
                    <Col xs={12} sm={12} md={6}>
                      <div className="field-title">
                        Name<span style={{ color: "#FF4444" }}>*</span>
                      </div>
                      <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={templateName} onChange={(e) => setTemplateName(e.target.value)} />
                      <span className="field-error">{validations.name}</span>
                    </Col>
                    <Col xs={12} sm={12} md={6} className="mt-2 mb-3">
                      <div className="field-title mb-2">Gate</div>
                      <AsyncSelect isMulti cacheOptions value={gate} loadOptions={fetchGate} onChange={handleGateChange} defaultOptions placeholder="Search gate..." styles={multiselectCustomStyles} isClearable={false} />
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} sm={12} className="mt-2">
                  <div className="field-title mb-2">
                    Content<span style={{ color: "#FF4444" }}>*</span>
                  </div>
                  {mediumOption?.value !== "sms" && mediumOption?.value !== "app-notification" ? (
                    <ReactQuill theme="snow" value={contentValue} onChange={setContentValue} />
                  ) : (
                    <>
                      <textarea placeholder="Enter here" className="input-field w-100" value={contentValue} onChange={(e) => setContentValue(e.target.value)} />
                      <span className="field-error">{validations.template}</span>
                    </>
                  )}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
};
